export default __webpack_public_path__ + "static/media/medicine_prescription_icon.34c67688.svg";